import React from "react";
import PropTypes from "prop-types";
import { Stepper, Step, StepLabel } from "@material-ui/core";

const StepperComponent = (props) => (
  <Stepper activeStep={props.activeStep}>
    {props.steps.map((stepData, index) => (
      <Step key={`step${index}`} completed={stepData.status}>
        <StepLabel>{stepData.text}</StepLabel>
      </Step>
    ))}
  </Stepper>
);

StepperComponent.propTypes = {
  activeStep: PropTypes.number,
  steps: PropTypes.array,
};

export default StepperComponent;
